/* beautiful-react-hooks version: 0.25.5 */
'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _rollupPluginBabelHelpers = require('./_virtual/_rollupPluginBabelHelpers.js');
var react = require('react');
var useGlobalEvent = require('./useGlobalEvent.js');

var useOnlineState = function useOnlineState() {
  var isSupported = typeof window !== 'undefined' && 'ononline' in window;

  var _useState = react.useState(isSupported ? navigator.onLine : true),
      _useState2 = _rollupPluginBabelHelpers.slicedToArray(_useState, 2),
      isOnline = _useState2[0],
      setIsOnline = _useState2[1];

  var whenOnline = useGlobalEvent.default('online', {
    capture: true
  });
  var whenOffline = useGlobalEvent.default('offline', {
    capture: true
  });

  if (!isSupported) {
    console.warn('The current device does not support the \'online/offline\' events, you should avoid using useOnlineState');
    return isOnline;
  }

  whenOnline(function () {
    setIsOnline(true);
  });
  whenOffline(function () {
    setIsOnline(false);
  });
  return isOnline;
};

exports.default = useOnlineState;
